import { createFileRoute, Link } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { z } from 'zod';

import { AgentAutomationDetailPage } from '@apps/web/components/automations/automation_surface';
import { useAdminOrganization } from '@apps/web/swr_data_fetching/data_fetching_hooks';

const searchSchema = z.object({
    mode: z.enum(['live', 'sandbox']).default('live'),
});

export const Route = createFileRoute(
    '/_app/admin/agent/automations/$organizationId/$automationId/',
)({
    head: () => ({
        meta: [
            {
                title: 'Automation | Phoebe Admin',
            },
        ],
    }),
    validateSearch: searchSchema,
    component: AdminAutomationDetailRoute,
});

function AdminAutomationDetailRoute() {
    const { automationId, organizationId } = Route.useParams();
    const { mode } = Route.useSearch();
    const {
        data: organization,
        isLoading,
        error,
    } = useAdminOrganization(organizationId);

    if (isLoading) {
        return (
            <div className="flex h-full min-h-64 items-center justify-center">
                <Loader2 className="text-muted-foreground h-6 w-6 animate-spin" />
            </div>
        );
    }

    if (error || !organization) {
        return (
            <div className="flex h-full min-h-64 flex-col items-center justify-center gap-3 p-6 text-center">
                <p className="text-sm font-medium">Organization not found</p>
                <p className="text-muted-foreground text-sm">
                    This organization could not be loaded.
                </p>
                <Link
                    to="/admin/agent/automations/list"
                    className="text-sm text-blue-700 hover:underline"
                >
                    Back to Agent Automations
                </Link>
            </div>
        );
    }

    return (
        <AgentAutomationDetailPage
            automationId={automationId}
            adminRouteContext={{
                actionsDisabled: false,
                mode,
                organizationId,
                organizationTimezone: organization.timezone,
            }}
        />
    );
}
